import { render, staticRenderFns } from "./AuthoriseSublet.vue?vue&type=template&id=2ab772ff&scoped=true"
import script from "./AuthoriseSublet.vue?vue&type=script&lang=js"
export * from "./AuthoriseSublet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab772ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab772ff')) {
      api.createRecord('2ab772ff', component.options)
    } else {
      api.reload('2ab772ff', component.options)
    }
    module.hot.accept("./AuthoriseSublet.vue?vue&type=template&id=2ab772ff&scoped=true", function () {
      api.rerender('2ab772ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthoriseSublet.vue"
export default component.exports